import React from 'react';
import { useTranslation } from 'react-i18next';
import PlanDeCuentaDropdown, { PLAN_CUENTA_DROPDOWN_MENU_Z_INDEX } from '../../../../../../containers/PlanDeCuentaDropdown';
import { parseAmountInput } from '../../../../../../utils/amountInput';
import './JournalEntryRow.scss';

const STRICT_AMOUNT_REGEX = /^\d*\.?\d{0,2}$/;
function looksLikeFormattedAmount(value) {
  return value.includes('$') || value.includes(',') || (value.match(/\./g)?.length ?? 0) > 1;
}

const JournalEntryRow = ({
  account,
  debit,
  credit,
  onAccountChange,
  onDebitChange,
  onCreditChange,
  onRemove,
  showRemoveButton = false,
  disabled = false,
  amountsReadOnly = false,
  accountPlaceholder,
  debitPlaceholder = "0",
  creditPlaceholder = "0",
}) => {
  const { t } = useTranslation('configuracion');
  const resolvedAccountPlaceholder = accountPlaceholder ?? t('journalEntryModal.selectAccount');

  const handleAccountChange = (e, data) => {
    if (onAccountChange) {
      onAccountChange(data?.account || null);
    }
  };

  const handleDebitChange = (e) => {
    const value = e.target.value;
    if (value === '' || STRICT_AMOUNT_REGEX.test(value)) {
      if (onDebitChange) onDebitChange(value);
      return;
    }
    if (looksLikeFormattedAmount(value)) {
      const parsed = parseAmountInput(value);
      if (parsed !== null && onDebitChange) onDebitChange(parsed);
    }
  };

  const handleCreditChange = (e) => {
    const value = e.target.value;
    if (value === '' || STRICT_AMOUNT_REGEX.test(value)) {
      if (onCreditChange) onCreditChange(value);
      return;
    }
    if (looksLikeFormattedAmount(value)) {
      const parsed = parseAmountInput(value);
      if (parsed !== null && onCreditChange) onCreditChange(parsed);
    }
  };

  const handleDebitPaste = (e) => {
    const text = e.clipboardData?.getData?.('text') ?? '';
    const parsed = parseAmountInput(text);
    if (parsed !== null) {
      e.preventDefault();
      if (onDebitChange) onDebitChange(parsed);
    }
  };

  const handleCreditPaste = (e) => {
    const text = e.clipboardData?.getData?.('text') ?? '';
    const parsed = parseAmountInput(text);
    if (parsed !== null) {
      e.preventDefault();
      if (onCreditChange) onCreditChange(parsed);
    }
  };

  return (
    <div className="journal-entry-row">
      {showRemoveButton && onRemove && (
        <button
          type="button"
          className="journal-entry-row-remove-x"
          onClick={onRemove}
          disabled={disabled}
          title={t('journalEntryModal.removeLine')}
          aria-label={t('journalEntryModal.removeLine')}
        >
          ×
        </button>
      )}
      <div className="journal-entry-row-account">
        <label className="journal-entry-amount-label">{t('journalEntryModal.account')}</label>
        <PlanDeCuentaDropdown
          value={account?.key || account || ''}
          onChange={handleAccountChange}
          placeholder={resolvedAccountPlaceholder}
          disabled={disabled}
          portalMenu
          menuZIndex={PLAN_CUENTA_DROPDOWN_MENU_Z_INDEX.MODAL}
        />
      </div>
      <div className="journal-entry-row-amounts">
        <div className="journal-entry-amount-group">
          <label className="journal-entry-amount-label">{t('journalEntryModal.debit')}</label>
          <input
            type="text"
            className="journal-entry-amount-input"
            value={debit !== '' && debit !== null && debit !== undefined ? debit : ''}
            onChange={handleDebitChange}
            onPaste={handleDebitPaste}
            placeholder={debitPlaceholder}
            disabled={disabled || amountsReadOnly}
            readOnly={amountsReadOnly}
            inputMode="decimal"
            aria-label={t('journalEntryModal.debit')}
          />
        </div>
        <div className="journal-entry-amount-group">
          <label className="journal-entry-amount-label">{t('journalEntryModal.credit')}</label>
          <input
            type="text"
            className="journal-entry-amount-input"
            value={credit !== '' && credit !== null && credit !== undefined ? credit : ''}
            onChange={handleCreditChange}
            onPaste={handleCreditPaste}
            placeholder={creditPlaceholder}
            disabled={disabled || amountsReadOnly}
            readOnly={amountsReadOnly}
            inputMode="decimal"
            aria-label={t('journalEntryModal.credit')}
          />
        </div>
      </div>
    </div>
  );
};

export default JournalEntryRow;


